import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

export default function PromoCodeListScreen() {
  const [code, setCode] = useState('');
  const [discountType, setDiscountType] = useState('percentage');
  const [discountValue, setDiscountValue] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [usageLimit, setUsageLimit] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        '/api/promos',
        {
          code: code.toUpperCase(),
          discountType,
          discountValue,
          expiresAt: expiresAt ? new Date(expiresAt) : undefined,
          usageLimit: usageLimit ? Number(usageLimit) : undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('userInfo')).token}`,
          },
        }
      );
      toast.success('Promo code created!');
      setCode('');
      setDiscountValue('');
      setExpiresAt('');
      setUsageLimit('');
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    }
  };

  return (
    <Card className="mx-auto my-5" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <h2 className="mb-3">Create Promo Code</h2>
        <Form onSubmit={submitHandler}>
          <Form.Group className="mb-3" controlId="code">
            <Form.Label>Code</Form.Label>
            <Form.Control
              type="text"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="discountType">
            <Form.Label>Discount Type</Form.Label>
            <Form.Select
              value={discountType}
              onChange={(e) => setDiscountType(e.target.value)}
            >
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed Amount</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="discountValue">
            <Form.Label>Discount Value</Form.Label>
            <Form.Control
              type="number"
              required
              value={discountValue}
              onChange={(e) => setDiscountValue(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="expiresAt">
            <Form.Label>Expires At</Form.Label>
            <Form.Control
              type="date"
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="usageLimit">
            <Form.Label>Usage Limit</Form.Label>
            <Form.Control
              type="number"
              value={usageLimit}
              onChange={(e) => setUsageLimit(e.target.value)}
            />
          </Form.Group>
          <div className="d-grid">
            <Button type="submit" variant="primary">
              Create Promo Code
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}